import Toaster from "@/mixins/Toaster/Toaster";
import Rights from "@/mixins/Rights/Rights";
import GroupBy from "@/mixins/GroupBy/GroupBy";

export default {
    mixins: [Toaster, Rights, GroupBy],
    data() {
        return {
            api: null,
            items: [],
            busy: false,
            prefetch: true,
            selected: {
                data: null,
                action: null,
                busy: false,
                title: ""
            }
        };
    },
    computed: {},
    created() {
        if (this.prefetch) {
            this.fetch();
        }
    },
    methods: {
        async fetch(busyState = true) {
            this.busy = busyState;
            const response = await this.api.get();
            if (response.ok) {
                var items = response.json.collection;
                items = items.map(item => this.process(item));
                this.items = items;
                this.registerRights(response);
            }
            this.busy = false;
        },
        process(item) {
            return item;
        },
        dataCreate() {
            const newObj = {};
            this.dataSet(newObj, "new", "Neu erstellen");
            this.$root.$emit("bv::show::modal", "editModal");
        },
        dataSelected(selectedItem) {
            this.dataSet(selectedItem, "edit", "Bearbeiten");
            this.$root.$emit("bv::show::modal", "editModal");
        },
        dataDelete(selectedItem) {
            this.dataSet(selectedItem, "remove", "Datensatz löschen");
            this.$root.$emit("bv::show::modal", "removeModal");
        },
        async dataProvide(evt) {
            evt.preventDefault();
            var selectedItem = this.selected.data;

            if (selectedItem) {
                // TODO: Validation
                this.selected.busy = true;
                var response = null;
                if (this.selected.action === "new") {
                    response = await this.api.post(selectedItem);
                } else if (this.selected.action === "remove") {
                    response = await this.api.delete(selectedItem.id);
                } else {
                    response = await this.api.put(
                        selectedItem.id,
                        selectedItem
                    );
                }

                var additionalResponse = true;
                if (
                    this.selected.action !== "new" &&
                    this.selected.action !== "remove"
                ) {
                    additionalResponse = await this.additionalRequests(
                        selectedItem
                    );
                }

                if (response.ok && additionalResponse) {
                    var currentItems = [...this.items];
                    if (this.selected.action === "new") {
                        selectedItem = this.postProcessCreate(
                            selectedItem,
                            response
                        );
                        currentItems.push(selectedItem);
                    } else if (this.selected.action === "remove") {
                        selectedItem = this.postProcessRemove(
                            selectedItem,
                            response
                        );
                        currentItems = currentItems.filter(item => {
                            return item.id !== selectedItem.id;
                        });
                    } else {
                        selectedItem = this.postProcessEdit(
                            selectedItem,
                            response
                        );
                        var changedIndex = currentItems.findIndex(item => {
                            return item.id === selectedItem.id;
                        });
                        currentItems[changedIndex] = selectedItem;
                    }

                    this.items = currentItems;

                    this.dataSet();
                    this.$root.$emit("bv::hide::modal", "newModal");
                    this.$root.$emit("bv::hide::modal", "editModal");
                    this.$root.$emit("bv::hide::modal", "removeModal");
                    this.makeToast(
                        "Erfolgreich gespeichert",
                        "Die Änderungen wurden erfolgreich in der Datenbank gespeichert"
                    );
                } else {
                    // TODO: Error handling
                    this.fetchErrorHandling(response);
                }
                this.selected.busy = false;
            }
        },
        dataHide(evt) {
            if (evt.trigger !== "ok") {
                this.dataSet();
            }
        },
        dataSet(data = null, action = null, title = "") {
            data = data ? { ...data } : null;
            this.selected = {
                data: data,
                action: action,
                title: title,
                busy: false
            };
            this.postDataSet();
        },
        postProcessCreate(selectedItem, response) {
            selectedItem.id = response.json.id;
            return selectedItem;
        },
        postProcessEdit(selectedItem, response) {
            return selectedItem;
        },
        postProcessRemove(selectedItem, response) {
            return selectedItem;
        },
        postDataSet() {},
        fetchErrorHandling(response) {},
        async additionalRequests(selectedItem) {
            return true;
        }
    }
};
